<ng-container *ngIf="popUp" id="tip-popup">
  <div class="row PopUp-text">
    <div class="col-5 col-lg-12 mobile-img-container">
      <img [src]="constants.tips_2_IMG" alt="" class="mobile-img-1" />
    </div>
    <div class="col-7 col-lg-12 wraper">
      <div class="PopUp-text-title-container">
        <div class="PopUp-text-title">Send {{creatorName}} a tip!</div>
        <div><i class="material-icons alert-btn-close teal-color closebutton1" (click)="closepopup()">close</i></div>
      </div>
      <div class="text-center">
        <img [src]="constants.tips_2_IMG" alt="" class="h-50 Image p-1 " />
      </div>
      <div class="PopUp-text-title-1 ">
        Tips are a great way to thank someone for sharing a window view that has helped you in some way.
      </div>
      <div class="amount-button-item">
        <button [ngClass]="{ 'select-class': amount == 3 }" class="amount-buttons p-2" value="3" #data
          (click)="clickEventHandler(data.value)">
          $3
        </button>

        <button [ngClass]="{ 'select-class': amount == 5 }" class="amount-buttons p-2" value="5" #data_1
          (click)="clickEventHandler(data_1.value)">
          $5
        </button>

        <button [ngClass]="{ 'select-class': amount == 10 }" class="amount-buttons p-2" value="10" #data_3
          (click)="clickEventHandler(data_3.value)">
          $10
        </button>
        <input (keyup)=onCickMore($event) type="number" name="more" id="more" placeholder="more"
          class="more-amount p-2">
      </div>

      <div class="footer-button rotate-items">
        <button class="send-tip-button" (click)="sendTips()" [disabled]="!getAmount">
          Send Tip
        </button>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="sendTipsPop">
  <div class="d-flex justify-content-between">
    <div><img [src]="constants.Back_ARROW_IMG" class="cursor" (click)="goBack()" /></div>
    <div><i class="material-icons alert-btn-close teal-color" (click)="closepopup()">close</i></div>
  </div>
  <div class="text-center title-send-amount">You are sending {{creatorName}} ${{amount}} </div>
  <form [formGroup]="getDetails" (ngSubmit)="onSubmit()" class="background">
    <div class="popup-2">
      <input type="text" placeholder="Name (Optional)" class="input-name" formControlName="name">
      <div class="text-wrap">
        <textarea class="w-100" formControlName="textarea" placeholder="{{placeholder}}"></textarea>
      </div>
      <div class="element-background">
        <ngx-stripe-card [options]="cardOptions" [elementsOptions]="elementsOptions" class="stripe"></ngx-stripe-card>
      </div>
      <div class="card-payment">
        <button [disabled]="paymentProcessing" class="payment-button" type="submit">
          Pay with card
        </button>
      </div>
      <p class="card-error">{{cardError}}</p>
      <!-- <div class="footer-part">
        <div class="text-input-div">
          <label class="checkbox">
            <input type="checkbox" class="text-inputs" formControlName="checkbox" />
            <span class="footer-1">Stay anonymous</span>
          </label>
        </div>
      </div> -->
    </div>
  </form>
</ng-container>
<ng-container *ngIf="payment">
  <div class="row">
    <div class="col-5 col-lg-12 image-mobile-wrapper">
      <img [src]="constants.thanks_IMG" alt="" class="final-image-mobile" />
    </div>
    <div class="col-7 col-lg-12 final-popup">
      <div class="">
        <div class="Final-text-title">You have thanked <br> {{creatorName}} with {{amount | currency}}</div>
        <div><i class="material-icons alert-btn-close teal-color closebutton1" (click)="closepopup()">close</i></div>
      </div>

      <div class="footer-img">
        <img [src]="constants.thanks_IMG" alt="" class="final-image" />
      </div>
      <div class="thanks-text">
        <div class="popup-text">
          Thank you for making WindowSwap </div>
        <div class="popup-text">a more rewarding place!</div>
      </div>
      <button (click)="onClose()" class="close-btn">Close</button>
    </div>
  </div>
</ng-container>